// eslint-disable-next-line max-lines-per-function
const defaultState = () => {
	return {
		codes: [
			{
				id: '6',
				key: 'common.strings.maxAdditions',
				message: 'Roster full or max additions used.',
			},
			{
				id: '7',
				key: 'errors.selectedPlayersMissmatchThLevel',
				message:
					'One or more selected players different Town Hall levels. Please select again and retry.',
			},
			{
				id: '8',
				key: 'errors.matchCheckinTooLate',
				message: 'Your team has missed the Match Check-In window.',
			},
			{
				id: '9',
				key: 'errors.tournamentCheckinFailedRow',
				message:
					'Tournament Check-In failed, please try again. If the issue persists please reach out to the Tournament Administration on Discord.',
			},
			{
				id: '10',
				key: 'errors.tournamentCheckinFailedCn',
				message:
					'Tournament Check-In failed, please try again. If the issue persists please reach out to the Tournament Administration on WeChat.',
			},
			{
				id: '11',
				headerKey: 'errors.matchCheckinGenericHeader',
				key: 'errors.matchCheckinErrorMissingMember',
				message:
					'You are missing a team member in your clan, please ensure that all team members are in the clan before attempting to Check-In.',
			},
			{
				id: '12',
				headerKey: 'errors.matchCheckinGenericHeader',
				key: 'errors.matchCheckinGenericCn',
				message:
					'Your War failed to start due to an unknown game error, please contact support via WeChat.',
			},
			{
				id: '13',
				headerKey: 'errors.matchCheckinGenericHeader',
				key: 'errors.matchCheckinGenericRow',
				message:
					'Your War failed to start due to an unknown game error, please contact support via Discord.',
			},
			{
				id: '14',
				headerKey: 'errors.matchCheckinExistingWarHeader',
				key: 'errors.ownTeamInActiveWarRow',
				message:
					'Your team is in an active Clan War or Friendly War. You cannot check-in while your Clan is in an active War. <BR/> Please contact support via Discord for further inquiries.',
			},
			{
				id: '15',
				headerKey: 'errors.tournamentCheckInMissingMemberHeader',
				key: 'errors.tournamentCheckInMissingMemberBodyRow',
				message:
					'You are missing one or more team members in the clan. Please ensure that all team members are in the clan before reattempting to Check-In. <BR/>Contact support via Discord for further inquiries.',
			},
			{
				id: '16',
				headerKey: 'errors.tournamentCheckInMissingMemberHeader',
				key: 'errors.tournamentCheckInMissingMemberBodyCn',
				message:
					'You are missing one or more team members in the clan. Please ensure that all team members are in the clan before reattempting to Check-In. <BR/>Contact support via WeChat for further inquiries.',
			},
			{
				id: '17',
				key: 'common.strings.captainRoleMismatchPersonal',
				message:
					'You are the team Captain but are not a co-leader or leader. Ask your clan leader to promote you or pick a new captain.',
			},
			{
				id: '18',
				headerKey: 'errors.matchCheckinExistingWarHeader',
				key: 'errors.ownTeamInActiveWarCn',
				message:
					'Your team is in an active Clan War or Friendly War. You cannot check-in while your Clan is in an active War. <BR/> Please contact support via WeChat for further inquiries.',
			},
			{
				id: '19',
				headerKey: 'errors.matchCheckinExistingWarHeader',
				key: 'errors.opponentInActiveWarCn',
				message:
					'Your opponent is in an active Clan War or Friendly War. If your opponent fails to complete Match Check-in, please contact support via WeChat.',
			},
			{
				id: '20',
				headerKey: 'errors.matchCheckinExistingWarHeader',
				key: 'errors.opponentInActiveWarRow',
				message:
					'Your opponent is in an active Clan War or Friendly War. If your opponent fails to complete Match Check-in, please contact support via Discord.',
			},
			{
				id: '21',
				headerKey: 'errors.clanSettingsHeader',
				key: 'errors.wrongClanSettingsCn',
				message:
					'An incorrect clan setting has prevented your War from starting. Please ensure that the Public War Log is enabled before reattempting to Check-In. <BR/> Contact support via WeChat for further inquiries.',
			},
			{
				id: '22',
				headerKey: 'errors.clanSettingsHeader',
				key: 'errors.wrongClanSettingsRow',
				message:
					'An incorrect clan setting has prevented your War from starting. Please ensure that the Public War Log is enabled before reattempting to Check-In. <BR/> Contact support via Discord for further inquiries.',
			},
			{
				id: '23',
				key: 'errors.cantQueueBecauseWar',
			},
			{
				id: '24',
				key: 'errors.cantQueueIncorrectSetup',
			},
			{
				id: '25',
				key: 'errors.stillUpcomingMatch',
			},
			{
				id: '26',
				headerKey: 'errors.matchLimitHeader',
				key: 'errors.matchLimitBody',
			},
			{
				id: '27',
				key: 'errors.clanMissmatchThLevel',
			},
			{
				id: '28',
				key: 'errors.clanReachedMaxMatches',
			},
			{
				id: '29',
				key: 'errors.bannedCountry',
			},
			{
				id: '30',
				key: 'errors.rosterErrorMissingMember',
			},
			{
				id: '31',
				key: 'errors.bannedPlayer',
			},
			{
				id: '32',
				key: 'errors.invalidClanLevel',
			},
			{
				id: '33',
				key: 'errors.segmentRegistrationNotOpen',
			},
			{
				id: '34',
				key: 'errors.eventNotActive',
			},
			{
				id: '35',
				key: 'errors.rosterChangesLimitExceeded',
			},
			{
				id: '36',
				key: 'errors.wrongMember',
			},
			{
				id: '37',
				key: 'errors.insufficientRole',
			},
		],
		lastestError: '',
	}
}

export const state = () => defaultState()

export const mutations = {
	setLatestError(state, lastestError) {
		state.lastestError = lastestError
	},
}

export const actions = {
	handleError({ rootState }, error) {
		// eslint-disable-next-line no-console
		console.error('handleError', error)

		try {
			this.$sentry.getCurrentScope().setContext('user', {
				playerTag: rootState?.playerTag,
				userId: rootState?.user?.userId,
			})

			if (error.response) {
				const { response } = error
				const url = response?.config?.url
				const statusCode = response?.headers?.['x-status-code'] || response?.status || 0
				const axiosError = new Error(`[ERROR][${statusCode}] ${url}`)
				axiosError.url = url
				axiosError.method = response?.config?.method
				axiosError.body = response?.config?.data
				axiosError.headers = response?.headers
				axiosError.status = response?.status
				axiosError.data = response?.data
				axiosError.request = response?.request
				this.$sentry.captureException(axiosError)
				return
			}

			if (error.message) {
				const ignoreMessages = [
					'Network Error',
					'timeout of 0ms exceeded',
					'Request aborted',
				]

				if (ignoreMessages.includes(error.message)) {
					return
				}
			}

			this.$sentry.captureException(error)
		} catch (e) {}
	},
}

export const getters = {}
